module.exports = __webpack_public_path__ + "img/crm-en-us.73752542.jpg";